// extracted by mini-css-extract-plugin
export default {"errorComponent":"errorElement_errorComponent__Q2Pni"};